import { useTasks } from "./useTasks";

export const useConfiguredTasks = () => {
  const tasks = useTasks();

  return Object.values(tasks).filter((t) => !t.unconfigured);
};
